import { render, staticRenderFns } from "./create-post.vue?vue&type=template&id=7fafa616&scoped=true&"
import script from "./create-post.vue?vue&type=script&lang=js&"
export * from "./create-post.vue?vue&type=script&lang=js&"
import style0 from "./create-post.vue?vue&type=style&index=0&id=7fafa616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fafa616",
  null
  
)

export default component.exports